var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInchis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 32"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0625,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_302_2791",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 17
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 4,
    y: 4.0625,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_302_2791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "lock_2",
    d: "M7.99996 18.7285C7.63329 18.7285 7.3194 18.598 7.05829 18.3368C6.79718 18.0757 6.66663 17.7618 6.66663 17.3952V10.7285C6.66663 10.3618 6.79718 10.048 7.05829 9.78685C7.3194 9.52574 7.63329 9.39518 7.99996 9.39518H8.66663V8.06185C8.66663 7.13963 8.99163 6.35352 9.64163 5.70352C10.2916 5.05352 11.0777 4.72852 12 4.72852C12.9222 4.72852 13.7083 5.05352 14.3583 5.70352C15.0083 6.35352 15.3333 7.13963 15.3333 8.06185V9.39518H16C16.3666 9.39518 16.6805 9.52574 16.9416 9.78685C17.2027 10.048 17.3333 10.3618 17.3333 10.7285V17.3952C17.3333 17.7618 17.2027 18.0757 16.9416 18.3368C16.6805 18.598 16.3666 18.7285 16 18.7285H7.99996ZM7.99996 17.3952H16V10.7285H7.99996V17.3952ZM12 15.3952C12.3666 15.3952 12.6805 15.2646 12.9416 15.0035C13.2027 14.7424 13.3333 14.4285 13.3333 14.0618C13.3333 13.6952 13.2027 13.3813 12.9416 13.1202C12.6805 12.8591 12.3666 12.7285 12 12.7285C11.6333 12.7285 11.3194 12.8591 11.0583 13.1202C10.7972 13.3813 10.6666 13.6952 10.6666 14.0618C10.6666 14.4285 10.7972 14.7424 11.0583 15.0035C11.3194 15.2646 11.6333 15.3952 12 15.3952ZM9.99996 9.39518H14V8.06185C14 7.50629 13.8055 7.03407 13.4166 6.64518C13.0277 6.25629 12.5555 6.06185 12 6.06185C11.4444 6.06185 10.9722 6.25629 10.5833 6.64518C10.1944 7.03407 9.99996 7.50629 9.99996 8.06185V9.39518Z",
    fill: "#7E8488"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInchis);
export default __webpack_public_path__ + "static/media/inchis.48842c669edad2fc8c5d1a02a295a25b.svg";
export { ForwardRef as ReactComponent };